import { useDispatch, useSelector } from "react-redux";
import { productCheckAgree } from "../../../../modules/reducers/productSearch/agreeProduct";

const useAgree = () => {
  const dispatch = useDispatch();

  const agreement = useSelector((state) => state.agreeProduct.agreement);

  const onHandleAgree = (agree) => {
    dispatch(productCheckAgree({ agreement: agree }));
  };

  return { onHandleAgree, agreement };
};

export default useAgree;
